// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DocumentTypeController from "./document_type_controller"
application.register("document-type", DocumentTypeController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)


import ReferenceTypeController from "./reference_type_controller"
application.register("reference-type", ReferenceTypeController)

import ServiceRequestTypeController from "./service_request_type_controller"
application.register("service-request-type", ServiceRequestTypeController)

import UnitPriceController from "./unit_price_controller"
application.register("unit-price", UnitPriceController)

import WorkflowAddonValidationController from "./workflow_addon_validation_controller"
application.register("workflow-addon-validation", WorkflowAddonValidationController)
